import { AssetID, AssetReference } from "@kosmod/assets";
import { K3D } from "@kosmod/graphics-3d";
import { ID, idDef } from "@kosmod/kit";
import { s } from "@kosmod/pancake";

import * as three from 'three';
import { faceDirection } from "three/src/nodes/TSL.js";
import { GameID } from "../sesame/defs";

export type DiceTemplateID = ID<"dice-template">;
export const DiceTemplateID = s.ref<DiceTemplateID>()(idDef);

export type DiceTemplateFace = {
  value: number,
  position: K3D.Vector3,
};
export const DiceTemplateFace = s.ref<DiceTemplateFace>()(s.o({
  value: s.num,
  position: K3D.Vector3,
}));

export type DiceTemplate = {
  name: string,
  id: DiceTemplateID,
  game: GameID,

  asset: AssetReference,
  modelPath: null | string,

  faceUpDirection: K3D.Vector3,
  faces: DiceTemplateFace[]
};
export const DiceTemplate = s.ref<DiceTemplate>()(s.o({
  name: s.str,
  id: DiceTemplateID,
  game: GameID,

  asset: AssetReference,
  modelPath: s.optional(s.str),

  faceUpDirection: K3D.Vector3,
  faces: s.a(DiceTemplateFace)
}))

export const createDiceTemplateFromObject3D = (game: GameID, object: three.Object3D, asset: AssetReference): DiceTemplate => {
  const faces = object.children.filter(c => c.userData.special_type === 'face')
    .map(face => ({
      position: face.position.clone().divideScalar(face.position.length()),
      value: face.userData['face_value']
    }))
    .sort((a, b) => a.value - b.value)

  return {
    name: `d${faces.length}`,
    id: ID('dice-template'),
    game,

    asset,
    modelPath: object.name,

    faceUpDirection: new three.Vector3(0, 1, 0),
    faces
  }
}